(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(['$compileProvider', function ($compileProvider) {
            $compileProvider.aHrefSanitizationWhitelist(/^\s*(|blob|):/);
        }])
        .controller('ArchivedBillingMainController', MainController);

   // AstbBillingController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];
    MainController.$inject = ['$scope', '$state'];

    function MainController ($scope, $state) {

        $scope.archivedBillingtabData   = [
            {
                heading: 'Authorization Fee Summary [non-NCTC] [choice of MSO]',
                route:   'archivedbilling-main.archived-nonnctc'

            },
            {
                heading: 'Authorization Fee Summary [NCTC]',
                route:   'archivedbilling-main.archived-nctc'
            },{
                heading: 'Authorization Fee Summary [DTA]',
                route:   'archivedbilling-main.archived-dta'
            },
            {
                heading: 'Revenue Summary',
                route:   'archivedbilling-main.archived-revenue'
            }
        ];

        $scope.go = function(route){
            $state.go(route);
        };

        $scope.months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

        var date = new Date();
        $scope.result = [];

        var dirty = false;
        for (var i = 2006; i <=  date.getFullYear(); i++) {
            angular.forEach($scope.months,function(month,index){
                if($scope.months[date.getMonth()] === month  &&  date.getFullYear() === i){
                    dirty = true;
                }
                if(dirty === false)
                    $scope.result.push(month+' '+i);
            });
        }
        $scope.result.reverse();

        $scope.month =   $scope.months[date.getMonth()-1] + ' ' + date.getFullYear();

        //$scope.go('');

    }
   /* function AstbBillingController ($scope, Principal, LoginService, $state) {

    }*/
})();
